// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"149590bc","193":"e8581f48","316":"54fe63f0","767":"da631ff6","771":"7ed4c61c","791":"2134a8c4","903":"da8e7270"}[chunkId] + ".chunk.js";
};